var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0.45586064126516956"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 150 0 L 292.658477444273 103.64745084375788 L 238.167787843871 271.3525491562421 L 61.832212156129046 271.35254915624216 L 7.341522555726954 103.64745084375792 Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 150 0 L 292.658477444273 103.64745084375788 L 238.167787843871 271.3525491562421 L 61.832212156129046 271.35254915624216 L 7.341522555726954 103.64745084375792 Z",
    fill: "rgba(191, 191, 191, 100)",
    transform: "scale(1, 1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 0 L 292.658477444273 103.64745084375788 L 238.167787843871 271.3525491562421 L 61.832212156129046 271.35254915624216 L 7.341522555726954 103.64745084375792 Z",
    fill: "none",
    stroke: "#0c0c0c",
    strokeWidth: 0,
    clipPath: "url(#clip-0.45586064126516956)",
    transform: "scale(1, 1)",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07);
export default __webpack_public_path__ + "static/media/07.38e095238052caa73c2e0d484ae9eabe.svg";
export { ForwardRef as ReactComponent };